import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=e3c0ae60&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=e3c0ae60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c0ae60",
  null
  
)

export default component.exports